import { DataSource } from '~/Api/DataSource';
import Price from '~/utils/Price';

export default class ReferencedProduct {
	id: string;

	currentExFactoryPrice: Price;

	dataSource: DataSource;

	constructor(id: string, currentExFactoryPrice: Price, dataSource: DataSource) {
		this.id = id;
		this.currentExFactoryPrice = currentExFactoryPrice;
		this.dataSource = dataSource;
	}
}
